export default __webpack_public_path__ + "static/copy_code-4ccba60b47468169d0b27a5ef41700de.png";